<template>
	<el-dialog :title="title" :visible.sync="dialogVisible" width="40%" :before-close="handleClose" append-to-body>
		<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
			<el-form-item label="学校" prop="schoolId">
				<el-select placeholder="请选择学校" v-model="ruleForm.schoolId" class="w-100" :disabled='disabled'>
					<el-option :label="item.name" :value="item.id" v-for="item in getSchoolArray"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="学院名称" prop="name">
				<el-input v-model="ruleForm.name" @input="inputName()"></el-input>
			</el-form-item>
			<el-form-item label="首字母" prop="firstLetter">
				<el-input v-model="ruleForm.firstLetter" :disabled="true"></el-input>
			</el-form-item>
		</el-form>
		<span slot="footer" class="dialog-footer">
			<el-button type="primary" @click="submitForm('ruleForm')">立即{{type==='add'?'添加':'修改'}}</el-button>
			<el-button @click="resetForm('ruleForm')">重置</el-button>
		</span>
	</el-dialog>
</template>

<script>
	import pinyin from '../../../../public/js/Convert_Pinyin.js'

	import {
		mapGetters
	} from 'vuex'

	export default {
		name: 'deptEdit',
		props: {
			type: {
				type: String,
				default: 'add'
			},
			title: {
				type: String
			},
			dialogVisible: {
				type: Boolean,
				default: false
			},
			obj: {
				type: Object,
				default: null
			},
			getSchoolArray: {
				type: Array,
				default: null
			},
			getDeptArrayName: {
				type: Array,
				default: null
			}
		},
		data() {
			return {
				ruleForm: {
					id: '',
					name: '',
					schoolId: '',
					firstLetter: ''
				},
				rules: {
					name: [{
						required: true,
						message: '请输入学院名称',
						trigger: 'blur'
					}],
					schoolId: [{
						required: true,
						message: '请选择学校',
						trigger: 'change'
					}]
				},
				disabled: false
			}
		},
		watch: {
			obj(val) {
				this.ruleForm = JSON.parse(JSON.stringify(val))
			}
		},
		computed: {
			...mapGetters(['getUserInfo'])
		},
		created() {
			if (this.getUserInfo.roleID == 2) {
				this.ruleForm.schoolId = this.getUserInfo.schoolID
				this.disabled = true
			}
		},
		methods: {
			inputName() {
				let e = pinyin.getFullChars(this.ruleForm.name).match(/[A-Z]/g)
				if (e != null)
					this.ruleForm.firstLetter = e.join('')
				else
					this.ruleForm.firstLetter = ''
			},
			refreshCode() {
				this.ruleForm.authCode = (Math.random() * 1e17).toString(36).substring(0, 10).toUpperCase()
			},
			submitForm(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						if (this.type === 'add' && this.getDeptArrayName.findIndex(
								item => item.schoolId === this.ruleForm.schoolId &&
								item.name === this.ruleForm.name) > -1) {
							this.$alert('已有重复的学院', '提示', {
								confirmButtonText: '确定',
								callback: action => {
									return false
								}
							})
							return false
						}

						if (this.type === 'update' && this.getDeptArrayName.findIndex(
								item => item.schoolId === this.ruleForm.schoolId &&
								item.name === this.ruleForm.name && this.obj.name != this.ruleForm.name) > -1) {
							this.$alert('已有重复的学院', '提示', {
								confirmButtonText: '确定',
								callback: action => {
									return false
								}
							})
							return false
						}
						this.type === 'add' && this.$http.post('api/Org/SaveDept', this.ruleForm).then(res => {
							this.handleClose()
						})
						this.type === 'update' && this.$http.post('api/Org/EditDept', this.ruleForm).then(res => {
							this.handleClose()
						})
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			resetForm(formName) {
				this.$refs[formName].resetFields();
			},
			handleClose() {
				this.$emit('before-close')
			}
		}
	}
</script>

<style>
</style>
